import { IGetProfessionalCountsByLocationParams } from '../../types/IGetProfessionalCountsByLocationParams';

export const factoryGetProfessionalCountsByLocationKey = ({
  lat,
  lng,
  distance,
  authorized,
}: IGetProfessionalCountsByLocationParams) =>
  ['GET_PROFESSIONAL_COUNTS_BY_LOCATION', lat, lng, distance, authorized] as const;
